import { render, staticRenderFns } from "./DataLevelTable.vue?vue&type=template&id=02718ef9"
import script from "./DataLevelTable.vue?vue&type=script&lang=js"
export * from "./DataLevelTable.vue?vue&type=script&lang=js"
import style0 from "./DataLevelTable.vue?vue&type=style&index=0&id=02718ef9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports